module.exports = __webpack_public_path__ + "static/media/address.47b5c1ef.svg";